import * as types from '../mutation-types'
import {
  addScript
} from '@/commons/utils'
import {
  requestUrl
} from '@/commons/config'
/**
 * home模块的store
 */

// state
const state = {

  list: [],
  isListEnd: false,
  orgList: [],
}

// getters
const getters = {
  list: state => state.list,
  isListEnd: state => state.isListEnd,
}

// actions
const actions = {

  getList({
    commit
  }, {
    page,
    type,
    onCompleted
  }) {



    var me = this;

    if (page == 1) {



      return new Promise((resolve, reject) => {

        var url = requestUrl.video.list(page, type);

        window['JQ_3c42cf2edf105ad172a61c9eef7097cc'] = window['JQ_8dfb823cd98999b77e04d61deabdb4e4'] =
          window["JQ_2f906963abfa705c491a32911aa449ff"] = window['JQ_8a2783ae91350e5b3078ee73418dcf1e'] = function(data) {
            data.map((item) => {

              item.isHover = false;
              item.isPlayer = false;
              item.lazyImage = "//cdn.jin10.com/assets/img/sites/video/lazy-bg.png";
              item.isShow = false;
              item.imgUrl2 = requestUrl.video.getEffect(item.id);
              item.isPause = true;
              item.isReset = false;
              item.isShowDesc = true;
              item.scrollTop = 0;
            });
            me.state.orgList = data;
            //alert(data.length);
            //con
            commit('getList', {
              data: data,
              page: page,
              onCompleted: onCompleted
            });

            resolve(data)
            // body...
          }
        //alert(url);
        addScript(url, function(argument) {

          //resolve([]);
        });
      })
    } else {
      commit('getList', {
        data: me.state.orgList,
        page: page,
        onCompleted: onCompleted
      });

    }
  }
}


var pageSize = 10;
// mutations
const mutations = {

  getList(state, {
    data,
    page,
    onCompleted
  }) {

    //alert(data.length);
    state.orgList = data;
    var newData = state.orgList.concat([]);



    //alert(state.orgList.length);
    if (page * pageSize >= state.orgList.length) {

      state.list = state.orgList;
      state.isListEnd = true;

    } else {
      newData.length = page * pageSize;
      state.list = newData;
      state.isListEnd = false;
    }



    if (onCompleted) {

      onCompleted(data);
    }
  },
  isItemShow(state, index) {

    return state.list[index].isShow;
  },
  setItemShow(state, index) {

    if (!state.list[index].isShow) {
      state.list[index].isShow = true;
    }

  },

  setItemScrollTop(state, {index,scrollTop}) {

    //if (state.list[index].isShow) {
    // console.log(scrollTop)
       state.list[index].scrollTop = scrollTop;
    //}
  }
}



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/video.js